import { type PropsWithChildren, createContext, useContext } from 'react';

interface Props {
  stepNumber: string;
}

const Context = createContext<Props>({ stepNumber: '0' });

export const StepperStepProvider = ({ children, ...props }: PropsWithChildren<Props>) => {
  return <Context.Provider value={props}>{children}</Context.Provider>;
};

export const useStepperStep = () => useContext(Context);
